import { render } from "./Navigation.vue?vue&type=template&id=079f1c8c&scoped=true&ts=true"
import script from "./Navigation.vue?vue&type=script&lang=ts"
export * from "./Navigation.vue?vue&type=script&lang=ts"

import "./Navigation.vue?vue&type=style&index=0&id=079f1c8c&scoped=true&lang=scss"

import exportComponent from "/Users/thomasplanckaert/Dedalus/GIT/carteconfituur/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-079f1c8c"]])

export default __exports__